<template>

  <!-- TABLE -->
  <tr v-if="vmode === 'table'"
  :class="{'selected': selected[item.id]}">
    <td class="sticky">
      <v-layout align-center>
        <v-btn
        icon
        @click.stop="$emit('checkRow', item)">
          <v-icon> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <v-avatar
        size="30px"
        color="green lighten-2"
        class="font-weight-light white--text mr-2">
            <span>
            {{ (item.name || '?').charAt(0) }}
            </span>
        </v-avatar>
        <span 
        class=""
        v-html="highlightedName">
        </span>
      </v-layout>
    </td>
    <td>
      {{ item.email }}
    </td>
    <td>
      {{ item.id }}
    </td>
  </tr>
</template>

<script>
export default {
  props:['item', 'vmode', 'searchText', 'selected'],
  data () {
    return {
      hover: false
    }
  },
  computed: {
    highlightedName () {
      if (!this.searchText) {
        return this.item.name
      }
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.name.replace(new RegExp(replacedStr, 'gi'), '<span class="green--text">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>

<style scoped lang="scss">

</style>